/**
 * Percentage value object: 0–100 (not 0–1). Discounts, tax rates, ratings.
 */
export type Percentage = number & { readonly __brand: 'Percentage' };

export function percentage(value: number): Percentage {
  if (!Number.isFinite(value) || value < 0 || value > 100) {
    throw new Error(`Invalid Percentage: ${value}`);
  }
  return value as Percentage;
}
